{
  "llmModelLabel": "Modelo LLM",
  "selectLlmModel": "Seleccionar un Modelo LLM",
  "imageUploadLabel": "Carga de imagen (jpg o png)",
  "dragDropText": "Arrastra y suelta para subir archivos",
  "browseFiles": "Explorar archivos",
  "executorLabel": "Ejecutor",
  "executorPlaceholder": "Esto será enviado a un agente para su ejecución",
  "invokeButton": "Invocar",
  "systemMessageLabel": "Mensaje del Sistema",
  "userMessageLabel": "Mensaje del Usuario",
  "orderSearchTool": "orderSearch",
  "orderSearchDescription": "Devuelve una lista de posibles órdenes en formato JSON.\nDebe usarse para obtener el identificador completo de la orden cuando esté incompleto tomando datos del primer elemento.",
  "orderInfoTool": "orderInfo",
  "orderInfoDescription": "Devuelve toda la información sobre una orden como narrativa.\n\nRequiere un identificador completo de orden en el formato YYYY/MM/DD/00000.",
  "partySearchTool": "partySearch",
  "partySearchDescription": "Devuelve una lista de información sobre posibles personas o empresas en formato JSON.\n\nDevuelve los nombres más aproximados y no hay forma de saber si se encontró una coincidencia exacta, se debe presentar una lista con la información coincidente en caso de duda.",
  "userInfoTool": "userInfo",
  "userInfoDescription": "Devuelve toda la información sobre el usuario en formato JSON.",
  "prompt": "Eres un investigador experimentado especializado en derecho inmobiliario de Texas, procedimientos y regulaciones.\n\n## Información del Usuario\n{{userInfo}}\n\n## Directrices de Respuesta\n- Refiere al usuario por su campo first_name cuando esté disponible\n- Mantén las respuestas breves pero completas\n- Dirígete al usuario por su nombre de pila de manera natural en la conversación\n- Presenta conjuntos de datos multi-campo como tablas markdown en lugar de prosa\n- Rechaza solicitudes de asesoría legal, representación o estrategia legal que requieran abogados licenciados\n- Utiliza todas las herramientas disponibles para seguir las instrucciones\n- Extrae y referencia campos relevantes de la información del usuario para proporcionar respuestas personalizadas y contextuales",
  "screenContentPrompt": "\n\nActualmente tengo la siguiente información en pantalla; considérala y determine si es relevante:{{screenContent}}",
  "assistant": "Asistente",
  "clearHistory": "Limpiar historial",
  "show-detail-ai": "Detalle de IA",
  "current-limits": "Límites Actuales",
  "hourly": "Por Hora",
  "weekly": "Semanal",
  "monthly": "Mensual",
  "no-usage": "La IA aún no se ha utilizado",
  "inference": "Inferencia",
  "close": "Cerrar",
  "resize-assistant": "Cambiar el tamaño del asistente",
  "expandAssistant": "Expandir a pantalla completa",
  "restoreAssistant": "Restaurar a vista lateral"
}
